<template>
	<page>
		<module enable-flex>
			<m-search ref="search" @search="searchHandle">
                <m-search-item label="标题">
                    <c-input name="case_title" placeholder="模糊匹配"></c-input>
                </m-search-item>
				<m-search-item label="发布时间" colspan="2">
					<c-datetime start-name="start_date" end-name="end_date" range></c-datetime>
				</m-search-item>
                <m-search-item label="状态" colspan="2">
                    <c-checkbox-group name="state" :options="stateOptions"></c-checkbox-group>
                </m-search-item>
			</m-search>
			
			<m-operate>
				<c-button color="main" @click="navigateTo('/success_case_add')">添加成功案例</c-button>
			</m-operate>
			
			<c-table ref="table" height="grow">
				<c-table-column
					type="selector"
				></c-table-column>

				<c-table-column
					label="状态"
					width="60"
					name="state"
				>
					<template #default="{data}">
                        <span v-if="data.state == 1" style="color: red">禁用</span>
                        <span v-if="data.state == 2" style="color: green">启用</span>
					</template>
				</c-table-column>

                <c-table-column
                        label="标题"
                        width="150"
                        name="case_title"
                ></c-table-column>

                <c-table-column
                        label="封面图"
                        width="80"
                        name="img_url"
                >
                    <template #default="{data}">
                        <c-file media :src="data.img_url" style="width:35px;height:35px"></c-file>
                    </template>
                </c-table-column>

                <c-table-column
                        label="发布人"
                        width="150"
                >
                    <template v-slot="{data}">
                        <p>{{data.create_user}}</p>
                    </template>
                </c-table-column>

                <c-table-column
                        label="发布时间"
                        width="150"
                >
                    <template v-slot="{data}">
                        <p>{{data.create_date}}</p>
                    </template>
                </c-table-column>

                <c-table-column
                        label="上次编辑人"
                        width="150"
                >
                    <template v-slot="{data}">
                        <p>{{data.edit_user}}</p>
                    </template>
                </c-table-column>
                <c-table-column
                        label="上次编辑时间"
                        width="150"
                >
                    <template v-slot="{data}">
                        <p>{{data.edit_date}}</p>
                    </template>
                </c-table-column>

                <c-table-column
                        type="sort"
                        label="排序"
                        name="sort_id"
                        @handle="sortHandle"
                >
                </c-table-column>
				<c-table-column
					type="button"
					label="操作"
					width="170"
				>
					<template #default="{data}">
                        <c-table-button v-if="auth('b_success_case_view')" @click="navigateTo(`/success_case_detail/${data.id}`)">查看</c-table-button>
						<c-table-button v-if="auth('b_success_case_edit')" @click="navigateTo(`/success_case_edit/${data.id}`)">编辑</c-table-button>
                        <c-table-button v-if="auth('b_success_case_edit') && data.state == 2" @click="stateHandle(data)">禁用</c-table-button>
                        <c-table-button v-if="auth('b_success_case_edit') && data.state == 1" @click="stateHandle(data)">启用</c-table-button>
                        <c-table-button v-if="auth('b_success_case_edit')" @click="delHandle(data)">删除</c-table-button>
					</template>
				</c-table-column>
			</c-table>
		</module>
	</page>
</template>

<script>
	import {mapState} from 'vuex'
	export default {
        name: 'm_success_case',
		components: {
        },
		
		props: {
			tab: String
		},
		
		data() {
			return {
                stateOptions: [
                    {name: '启用',value:2},
                    {name: '禁用',value:1},
                ]
			}
		},
		
		computed: {
			...mapState(['userInfo']),
		},
		
		mounted() {
            this.$refs.search.search();
			this.$onBus('successCaseUpdate', () => {
				this.selectClassify();
			});
		},
		
		beforeDestroy() {
			this.$offBus('successCaseUpdate');
		},
		
		methods: {
			searchHandle(data) {
				this.$refs.table.load({
					url: '/success_case/list',
					data: data
				});
			},
			delHandle(params) {
				this.$confirm({
					message: '确定要删除【'+params.case_title+'】成功案例吗？',
					resolve: () => {
						this.request({
							url: '/success_case/del',
							data: {
								id: params.id
							},
							loading: true,
							success: data => {
								this.$message({
									message: '删除成功',
									type: 'success'
								});
                                this.$refs.table.update();
							}
						});
					}
				});
			},
            stateHandle(params){
                this.$confirm({
                    message: '确定要'+(params.state==1 ? '启用' : '禁用')+'【'+params.case_title+'】案例吗？',
                    resolve: () => {
                        this.request({
                            url: '/success_case/state',
                            data: {
                                id: params.id,
                                state: params.state==1 ? 2 : 1
                            },
                            loading: true,
                            success: data => {
                                this.$message({
                                    message: '操作成功',
                                    type: 'success'
                                });
                                this.$refs.table.update();
                            }
                        });
                    }
                });
            },
            sortHandle(row, type, next) {
                //row.prev() 上一行数据
                //row.next() 下一行数据
                let submitData ={};
                if(type=='top' || type=='bottom'){
                    submitData.type = type;
                    submitData.id = row.data.id;
                }
                if(type=='up'){
                    submitData.id1 = row.data.id;
                    submitData.id2 = row.prev().data.id;
                }
                if(type=='down'){
                    submitData.id1 = row.data.id;
                    submitData.id2 = row.next().data.id;
                }
                this.request({
                    url: '/success_case/sort',
                    data: submitData,
                    loading: true,
                    success: data => {
                        next();
                    }
                });
            },
		}
	}
</script>

